// extracted by mini-css-extract-plugin
export default {"containerBlock":"Home_containerBlock__+n3nE","photoContainer":"Home_photoContainer__sujD6"};